import { useForm } from 'antd/lib/form/Form';
import { useState } from 'react';
import { createRoom } from 'services/api';
import type { RoomFormValues } from '../../types';

interface UseCreateServiceProps {
  buildingId: number;
  hide: () => void;
  onItemCreate: () => void;
}

export const useCreateService = ({ buildingId, hide, onItemCreate }: UseCreateServiceProps) => {
  const [form] = useForm<RoomFormValues>();
  const [loading, setLoading] = useState(false);

  const hideModal = () => {
    hide();
    form.resetFields();
  };

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      createRoom({
        ...values,
        buildingId: buildingId,
      })
        .then(() => {
          hideModal();
          onItemCreate();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  };
};
